(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "vue", "./shared/mixin", "./shared/constants"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("vue"), require("./shared/mixin"), require("./shared/constants"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.vue, global.mixin, global.constants);
    global.install = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _vue, _mixin, _constants) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  _exports.__esModule = true;
  _exports["default"] = void 0;
  _vue = _interopRequireDefault(_vue);
  _mixin = _interopRequireDefault(_mixin);

  function install(Vue, options) {
    if (install.installed) return;
    install.installed = true;

    if (_vue["default"] !== Vue) {
      // eslint-disable-next-line
      console.error("Multiple instances of Vue detected");
    }
    /**
     * this.$wx().sdk.run('hideMenuItems').then(() => {})
     * this.$wx().refresh();
     * this.$wx().stop();
     * this.$wx().resume();
     */


    Vue.prototype.$wx = function () {
      var _this = this;

      return {
        sdk: options.sdk,
        refresh: function refresh() {
          if (_this.$root[_constants.rootConfigKey[_constants.pausing]]) {
            return;
          }
          /**
           * const { $children } = this;
           * // deeply tranverse the $children, update the vuewx.
           */

        },
        stop: function stop() {
          _this.$root[_constants.rootConfigKey][_constants.pausing] = true;
        },
        resume: function resume() {
          _this.$root[_constants.rootConfigKey][_constants.pausing] = false;
        }
      };
    };

    Vue.mixin((0, _mixin["default"])(Vue, options));
  }

  var _default = {
    version: "0.1.0",
    install: install
  };
  _exports["default"] = _default;
});
//# sourceMappingURL=install.js.map